import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { M8UserProfile } from 'services/production/types';
import { getM8UserURL } from 'services/production/utils/getM8URL';

export const getQuestionnaireInfo = async (): Promise<M8UserProfile> => {
  const response = await customFetch(getM8UserURL('getQuestionnaireInfo'));

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
